import {PhoneDto} from "./phone.dto";
import {AddressDto} from "./address.dto";
import {EmailDto} from "./email.dto";
import {BankAddressDto} from "./bank-address.dto";
import {isDefined, isTrue, isUuid, notDefined} from "../../libs/utils/epic.utils";
import {OccurrenceDto} from "./occurrence.dto";
import {ContactType} from "../../libs/enum/contact-type";
import {HyperlinkDto} from "./hyperlink.dto";
import {ContactCategory} from "../../libs/enum/contact-category.enum";
import {EmployeeType} from "../../libs/enum/employee-type.enum";

export class ContactDto {

  public id!: string;
  public type!: ContactType;
  public number!: string;
  public name!: string;
  public firstname: string | undefined;
  public salutation: string | undefined;
  public academicDegree: string | undefined;
  public languageCode: string | undefined;
  public debtorNumber: string | undefined;
  public debtorTaxId: string | undefined;
  public debtorSector: string | undefined;
  public creditorNumber: string | undefined;
  public creditorTaxId: string | undefined;
  public creditorSector: string | undefined;
  public creditorOwnNumber: string | undefined;
  // Employee: Typ
  public employeeType: EmployeeType | undefined;
  // Employee: Identifikationsnummer / Identification number / ID number
  public idNumber: string | undefined;
  // Employee: Sozialversicherungsnummer / National insurance number
  public insuranceNumber: string | undefined;
  // Employee: Lohn / Gehalt
  public salary: number | undefined;
  // Employee: Stadtbürgerschaft / Nationality / Citizenship
  public nationality: string | undefined; // Country-Code
  public notes: string | undefined;
  public externalId: string | undefined;
  public externalNumber: string | undefined;
  public readonly companyContactCount!: number;
  public /* readonly */ contactRelationCount!: number;
  public readonly vehicleCount!: number;
  public readonly editable!: boolean;
  public contactId: string | undefined;
  public categories: ContactCategory[] = [];
  public /* readonly */ emails: EmailDto[] = [];
  public /* readonly */ phones: PhoneDto[] = [];
  public /* readonly */ addresses: AddressDto[] = [];
  public /* readonly */ bankAddresses: BankAddressDto[] = [];
  public /* readonly */ occurrences: OccurrenceDto[] = [];
  public /* readonly */ hyperlinks: HyperlinkDto[] = [];
  // [FIRSTNAME] + NAME
  public readonly fullName: string = '';

  constructor(init?: Partial<ContactDto> | undefined) {
    Object.assign(this, init);
    if (isDefined(init?.categories)) {
      this.categories = init.categories;
    } else {
      this.categories = [];
    }
    if (isDefined(init?.emails)) {
      this.emails = init.emails.map((i) => new EmailDto(i));
    } else {
      this.emails = [];
    }
    if (isDefined(init?.phones)) {
      this.phones = init.phones.map((i) => new PhoneDto(i));
    } else {
      this.phones = [];
    }
    if (isDefined(init?.addresses)) {
      this.addresses = init.addresses.map((i) => new AddressDto(i));
    } else {
      this.addresses = [];
    }
    if (isDefined(init?.bankAddresses)) {
      this.bankAddresses = init.bankAddresses.map((i) => new BankAddressDto(i));
    } else {
      this.bankAddresses = [];
    }
    if (isDefined(init?.occurrences)) {
      this.occurrences = init.occurrences.map((i) => new OccurrenceDto(i));
    } else {
      this.occurrences = [];
    }
    if (isDefined(init?.hyperlinks)) {
      this.hyperlinks = init.hyperlinks.map((i) => new HyperlinkDto(i));
    } else {
      this.hyperlinks = [];
    }
  }

  public isEditable(): boolean {
    return notDefined(this.editable) || isTrue(this.editable);
  }

  // Used in Contact-List
  // noinspection JSUnusedGlobalSymbols
  public hasVehicles(): boolean {
    return this.vehicleCount > 0;
  }

  public isChildContact(): boolean {
    return isUuid(this.contactId);
  }

  public notChildContact(): boolean {
    return !this.isChildContact();
  }

  public hasCategory(category: ContactCategory): boolean {
    return this.categories.includes(category);
  }

  public getPrimeAddress(): AddressDto | undefined {
    return this.addresses.find((a) => a.prime);
  }

  public getPrimeEmail(): EmailDto | undefined {
    return this.emails.find((e) => e.prime);
  }
}
